import axios from 'axios';

import { API_ENDPOINT } from 'constants/api';
import { getDomainName } from 'utils/domain';
import { checkIsAppLoadedInIframe } from 'utils/iframe';

const skynetAPI = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    domainname: getDomainName(),
    isHubspotSession: checkIsAppLoadedInIframe(),
  },
});

export default skynetAPI;
